import { Component, Input } from '@angular/core';
import { IconSize } from '../core-data-model/IconSize';
import { IconType } from '../core-data-model/IconType';
import { TranslationService } from '../translations/Translation.service';

@Component({
    selector: 'feedback-tag',
    template: `
        <div class="feedback-tag--container layout--center">
            <abstract-icon
                [iconType]="IconType.Feedback"
                [iconSize]="IconSize.Medium"
            ></abstract-icon>
            <span>{{ feedbackButtonText }}</span>
        </div>
    `,
    standalone: false
})
export class FeedbackTagComponent {
    IconType = IconType;
    IconSize = IconSize;

    @Input()
    feedbackButtonText: "this.TR.key('common.feedback')";

    constructor(public TR: TranslationService) {}
}
